import { createContext, useReducer } from 'react';
import { WorkflowAction } from '~/lib/types/workflow-types';
import { onlyUnique } from '~/lib/utils/array';

export interface IWorkflowContext {
  completedActions: WorkflowAction[];
  data: Map<WorkflowAction, boolean | string | number | object>;
}

export interface IAddCompletedAction {
  type: 'COMPLETED_ACTION';
  payload: WorkflowAction;
}

export interface IClearCompletedAction {
  type: 'CLEAR_COMPLETED_ACTIONS';
  payload: WorkflowAction[];
}

export interface ISetWorkflowDataAction {
  type: 'SET_DATA';
  name: WorkflowAction;
  payload: boolean | string | number | object;
}

export type WorkflowContextActions = IAddCompletedAction | ISetWorkflowDataAction | IClearCompletedAction;

const initialState: IWorkflowContext = {
  completedActions: [],
  data: new Map<WorkflowAction, boolean | string | number | object>()
};

type WorkflowContextState = {
  state: IWorkflowContext;
  dispatch: (action: WorkflowContextActions) => void;
};

const WorkflowContext = createContext<WorkflowContextState>({
  state: initialState,
  dispatch: () => {}
});

const reducer = (state: IWorkflowContext, action: WorkflowContextActions): IWorkflowContext => {
  switch (action.type) {
    case 'COMPLETED_ACTION':
      return { ...state, completedActions: [...state.completedActions, action.payload].filter(onlyUnique) };
    case 'SET_DATA':
      return { ...state, data: new Map(state.data.set(action.name, action.payload)) };
    case 'CLEAR_COMPLETED_ACTIONS':
      return { ...state, completedActions: state.completedActions.filter((x) => !action.payload.includes(x)) };
  }
  return state;
};

type BasketProviderProps = {
  children: React.ReactNode;
};

const WorkflowProvider: React.FC<BasketProviderProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <WorkflowContext.Provider value={value}>{props.children}</WorkflowContext.Provider>;
};

const WorkflowConsumer = WorkflowContext.Consumer;

export { WorkflowContext, WorkflowProvider, WorkflowConsumer };
